<template>
<v-stepper v-if="!isLoggedIn" style="width: 100%;" v-model="loginStep" id="Login">
    <v-btn
      v-if="!hideClose"
      icon
      class="close-btn"
      @click="closeModal"
    >
      <i class="v-icon material-icons">cancel</i>
    </v-btn>
  <div class="header-container">
    <v-stepper-header v-if="loginStep < 3" class="header-title">
      <h2 v-if="loginStep == 1" class="title-text">
        {{ $vuetify.t('$vuetify.common.login') }}
      </h2>
      <h2 v-if="loginStep == 2" class="title-text">
        {{ $vuetify.t('$vuetify.common.verify') }}
      </h2>
    </v-stepper-header>
  </div>
  <v-stepper-items>
    <v-stepper-content step="1" class="py-0">
      <!-- <v-text-field
        class="mt-0"
        name="phone_number"
        v-validate="'required|digits:10'"
        :data-vv-as="$vuetify.t('$vuetify.common.mobileNumber')"
        :error-messages="errors.collect('phone_number')"
        ref="txtPhoneNumber"
        v-model="mobileNumber"
        :label="$vuetify.t('$vuetify.common.mobileNumber')"
        mask="NNNNNNNNNN"
        return-masked-value
        type="number"
        v-on:keyup.enter="onLogin"
        autocomplete="tel"
      ></v-text-field> -->
      <strong v-if="openedFromThumbsUp" style="font-size: 12px">
        {{ $vuetify.t('$vuetify.common.loginDescription') }}
      </strong>
      <v-text-field
        class="mt-0 phone-input"
        name="phone_number"
        v-validate="'required|digits:10'"
        :data-vv-as="$vuetify.t('$vuetify.common.mobileNumber')"
        :error-messages="errors.collect('phone_number')"
        ref="txtPhoneNumber"
        :value="mobileNumber"
        :label="$vuetify.t('$vuetify.common.mobileNumber')"
        type="tel"
        v-on:keyup.enter="onLogin"
        @focus="handleFocus"
        @input="value => mobileNumber = value.replace(/[^0-9]/g, '').slice(0, 10)"
        autocomplete="tel"
        solo
        flat
        background-color="#F5F5F5"
        hide-details
        dense
      ></v-text-field>
      <div style="margin-bottom: 10px;">
        <div v-if="!isLoggedIn && !hasConsentForGroup" class="disclaimer consent-row">
          <v-checkbox
            v-model="consentChecked"
            class="consent-checkbox"
            hide-details
            dense
            :ripple="false"
          />
          <span v-html="formattedDisclaimer" class="consent-text"></span>
        </div>
      </div>
      <v-layout row wrap justify-center style="align-items: center;">
        <v-flex class="text-xs-center" :class="canCheckoutAsGuest && notLoggedInAndCanSkipCheckout ? 'xs6' : 'xs12'">
          <v-btn class="done-button" style="height: 50px !important" color="primary" :loading="isLoading" @click="onLogin()" :disabled="!canLogin">
            {{ $vuetify.t('$vuetify.common.continue') }}
          </v-btn>
        </v-flex>

        <template v-if="(canCheckoutAsGuest && notLoggedInAndCanSkipCheckout)">
          <v-flex xs2 style="padding: 10px 0px; text-align: center">
            or
          </v-flex>

          <v-flex xs4>
            <v-btn class="done-button"  style="height: 50px !important" color="primary" :disabled="!getLocalCart.length" @click="onChangeGuestLogin(true)">
              {{ $vuetify.t('$vuetify.common.guest') }}
            </v-btn>
          </v-flex>
        </template>
      </v-layout>
    </v-stepper-content>

    <v-stepper-content step="2" class="pt-0">
      <template>
            <p class="grey--text text--darken-1" style="text-align: center">
              We've sent a code to <strong>{{ mobileNumber | phone }}</strong>
            </p>

            <v-layout row justify-center class='layout-verify'>
              <v-text-field
                v-for="(digit, index) in loginCode"
                :key="index"
                class="otp-box"
                v-model="loginCode[index]"
                ref="otpInput"
                type="tel"
                :maxlength="index === 0 ? '6' : '1'"
                :autocomplete="index === 0 ? 'one-time-code' : 'off'" 
                @input="handleInput($event, index)"
                @keydown="handleKeydown($event, index)"
                @paste="handlePaste($event)"
                @blur="handleBlur($event, index)"
                solo
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-layout>

            <p class="mt-2 text-caption"  style="text-align: center">
              Didn’t get a code?
              <span v-if="timeoutLeftRemoving > 0">Click to Resend (Resend in {{ timeoutLeftRemoving }}s)</span>
              <a v-else @click="onLogin" class="text-decoration-underline">Click to Resend</a>
            </p>

          <v-card-actions class="justify-space-between">
             <v-btn class="options-button" color="primary" @click="loginStep = 1">
              Back
            </v-btn>
            <v-btn class="options-button" color="primary" :loading="isLoading" @click="onVerifyCode()">
              Verify Code
            </v-btn>
          </v-card-actions>

          <!-- <div v-if="isDineIn" style="text-align: center; margin-top: 10px; font-size: 10px; color: #808080;">
            {{ $vuetify.t('$vuetify.common.captcha.main') }}
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a>
          </div> -->
      </template>
      <!-- <div class="curNumber">
        {{mobileNumber | phone}} {{ timeoutLeftRemoving }}
      </div>
      <v-text-field
        class="mt-0"
        name="login_code"
        v-validate="'required|digits:6'"
        :data-vv-as="$vuetify.t('$vuetify.common.sixDigitCode')"
        :error-messages="errors.collect('login_code')"
        ref="txtVerifyCode"
        v-model="loginCode"
        :label="$vuetify.t('$vuetify.common.sixDigitCode')"
        mask="NNNNNN"
        return-masked-value
        type="number"
        v-on:keyup.enter="onVerifyCode"
      ></v-text-field>

      <v-layout row wrap style="justify-content: space-between">
        <v-flex xs5 class="text-xs-center">
          <v-btn class="done-button" color="primary" @click="loginStep = 1">
            {{ $vuetify.t('$vuetify.common.cancel') }}
          </v-btn>
        </v-flex>
        <v-flex xs5 class="text-xs-center">
          <v-btn class="done-button" v-if="!showResend" color="primary" :loading="isLoading" @click="onVerifyCode()">
            {{ $vuetify.t('$vuetify.common.verifyCode') }}
          </v-btn>
          <v-btn class="done-button" v-else color="primary" :loading="isLoading" @click="onLogin()">
            {{ $vuetify.t('$vuetify.common.newCode') }}
          </v-btn>
        </v-flex>
      </v-layout> -->
    </v-stepper-content>

    <v-stepper-content step="3" class="py-0">
      <v-layout 
        v-if="canCheckoutAsGuest" 
        row 
        wrap 
        class="guest-actions-container"
      >
        <v-flex xs8>
          <v-btn 
            block
            class="guest-action-btn" 
            color="primary" 
            :disabled="loading || !getLocalCart.length" 
            :loading="loading" 
            @click="onGuestAction"
          >
            <span v-if="!getLocalCart.length && getExistingOrder.length">
              {{ $vuetify.t('$vuetify.cart.processing') }}
            </span>
            <span v-else>
              {{ $vuetify.t('$vuetify.cart.btnSubmitSubOrder') }}
            </span>
          </v-btn>
        </v-flex>

        <v-flex v-if="!isInKioskMode" xs8>
          <v-btn 
            block
            class="guest-action-btn" 
            color="primary" 
            @click="onChangeGuestLogin(false)"
          >
            {{ $vuetify.t('$vuetify.cart.backToLogin') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-stepper-content>
  </v-stepper-items>
    <div v-if="isDineIn" style="text-align: center; margin-top: 10px; font-size: 10px; color: #808080">
      {{ $vuetify.t('$vuetify.common.captcha.main') }}
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a>
    </div>

  <!-- <div v-if="!isLoggedIn" class="captcha">
    {{ $vuetify.t('$vuetify.common.captcha.main') }}
        <a href="https://policies.google.com/privacy"> {{ $vuetify.t('$vuetify.common.captcha.privacy') }} </a> {{ $vuetify.t('$vuetify.common.captcha.and') }}
        <a href="https://policies.google.com/terms"> {{ $vuetify.t('$vuetify.common.captcha.terms') }} </a> {{ $vuetify.t('$vuetify.common.captcha.apply') }}
  </div> -->
</v-stepper>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import get from 'lodash/get';
  import { findErrorMessage, matchTranslation } from '@/services/util.service'

  export default {
    name: 'login',
    
    props: {
      hideClose: {
        type: Boolean,
        default: false
      },
      openedFromThumbsUp: {
        type: Boolean,
        default: false
      },
      resetOpenThumbsUp: {
        type: Function,
        required: true 
      }
    },
    data() {
      return {
        selectedGuestLogin: false,

        showResend: false,
        interval: null,
        timeoutCounter: 0,

        isLoading: false,
        loginStep: 1,
        mobileNumber: '',
        loginCode: ['', '', '', '', '', ''],
        referrer: '',
        consentChecked: false,
      }
    },
    computed: {
      canLogin() {
        return this.hasConsentForGroup || this.consentChecked;
      },
   
      storeGroupId() {
        if (this.getStore) {
          if (this.getStore.groupId) {
            return this.getStore.groupId;
          } else if (this.getStore.storeId) {
            return this.getStore.storeId;
          }
        }
        return null;
      },
      hasConsentForGroup() {
        if (!this.storeGroupId) return false;
        try {
          const consentedGroups = JSON.parse(localStorage.getItem('snappy_login_consent_groups') || '[]');
          return consentedGroups.includes(this.storeGroupId);
        } catch (e) { return false; }
      },
      formattedDisclaimer() {
        const customToS = matchTranslation(get(this.getGroup, 'settings.owaSettings.customToS.translations', []));
        if (customToS) {
          return customToS.replace(
            /\[([^\]]+)\]\s*\{([^}]+)\}/g,
            '<a href="$2" target="_blank" rel="noopener">$1</a>'
          );
        }
        return this.$vuetify.t('$vuetify.common.disclaimer.main')
          .replace(/{businessName}/g, this.businessName)
          .replace(
            /<link-tos>(.*?)<\/link-tos>/g,
            '<a href="https://gosnappy.io/terms-of-service.html" target="_blank" rel="noopener">$1</a>'
          )
          .replace(
            /<link-pp>(.*?)<\/link-pp>/g,
            '<a href="https://gosnappy.io/privacy-policy.html" target="_blank" rel="noopener">$1</a>'
          );
      },
      timeoutLeftRemoving() {
        if (this.timeoutCounter !== null) {
          return this.$vuetify.t('$vuetify.common.resend', [60 - this.timeoutCounter])
        }
      },

      canCheckoutAsGuest() {
        return !this.isLoggedIn && this.isDineIn && this.allowAnonymousDineIn && this.skipCheckout === true
      },

      notLoggedInAndCanSkipCheckout() {
        // @todo refactor with button refactor; store closed should be extracted
        // NOTE: The state "skipCheckout" only looks for stores with JUST "offline" ordering
        // we dont care about this since the user is not logged in. We just care about the setting itself.
        const hasSetting = get(this.getStore, 'settings.owaSettings.skipCheckout', false) === true

        return !this.isLoggedIn && this.storeIsAvailable && hasSetting
      },

      loading: {
        get() {
          return this.isCartLoading
        },
        set(_val) {
          this.SET_CART_LOADING(_val)
        }
      },

      businessName() {
        if (this.getGroup) {
          // First priority: current language translation
          const currentLang = this.$vuetify.lang.current;
          if (this.getGroup.groupNameTranslation && this.getGroup.groupNameTranslation.translations) {
            const currentLangTranslation = this.getGroup.groupNameTranslation.translations.find(
              t => t.lang === currentLang
            );
            if (currentLangTranslation && currentLangTranslation.value) {
              return currentLangTranslation.value;
            }
          }
          
          // Second priority: regular group name
          if (this.getGroup.groupName) {
            return this.getGroup.groupName;
          }
          
          // Third priority: English translation
          if (this.getGroup.groupNameTranslation && this.getGroup.groupNameTranslation.translations) {
            const englishTranslation = this.getGroup.groupNameTranslation.translations.find(
              t => t.lang === 'en'
            );
            if (englishTranslation && englishTranslation.value) {
              return englishTranslation.value;
            }
          }
        }
        
        // Fourth priority: store name, final fallback: 'Snappy'
        return (this.getStore && this.getStore.name) || 'Snappy';
      },

      ...mapGetters([
        'isCartLoading',
        'getExistingOrder',
        'getLocalCart',
        'getStore',
        'getGroup',
        'isDineIn',
        'isLoggedIn',
        'storeIsAvailable',
        'skipCheckout',
        'allowAnonymousDineIn',
        'isInKioskMode',
        'isSelectedGuestLogin',
        'getOpenReferral'
      ]),
    },

    methods: {
      handlePaste(event) {
        event.preventDefault();
        const pastedData = event.clipboardData.getData('text').replace(/[^0-9]/g, ''); 

        for (let i = 0; i < this.loginCode.length; i++) {
          this.loginCode[i] = pastedData[i] || ''; 
        }

        if (this.loginCode.every(code => code && code.length === 1)) {
          this.onVerifyCode();
        }
      },
      handleFocus(event) {
        setTimeout(() => {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      },
      handleInput(value, index) {
        const numericValue = value.replace(/[^0-9]/g, ''); 
        
        // Handle autofill case - if first input gets a full 6-digit code
        if (index === 0 && numericValue.length === 6) {
          this.distributeSixDigitCode(numericValue);
          return;
        }
        
        // Handle multi-digit paste or input
        if (numericValue.length > 1) {
          this.distributeSixDigitCode(numericValue);
        } else {
          this.loginCode[index] = numericValue.slice(0, 1);
        }
        
        // Move to next input for single digit entry
        if (numericValue && index < this.loginCode.length - 1 && numericValue.length === 1) {
          this.$nextTick(() => {
            const inputs = document.querySelectorAll('.otp-box input');
            if (inputs[index + 1]) {
              inputs[index + 1].focus();
            }
          });
        }
        
        // Check for completion after a short delay (helps catch iOS autofill)
        setTimeout(() => {
          if (this.loginCode.every(code => code && code.length === 1)) {
            this.onVerifyCode();
          }
        }, 100);
      },

      handleChange(value, index) {
        const numericValue = value.replace(/[^0-9]/g, ''); 
        
        if (index === 0 && numericValue.length === 6) {
          this.distributeSixDigitCode(numericValue);
        }
      },

      handleBlur(value, index) {
        // iOS autofill sometimes triggers on blur instead of input
        if (index === 0) {
          setTimeout(() => {
            const firstInputValue = this.loginCode[0];
            if (firstInputValue && firstInputValue.length > 1) {
              this.distributeSixDigitCode(firstInputValue);
            }
          }, 50);
        }
      },

      distributeSixDigitCode(code) {
        const numericValue = code.replace(/[^0-9]/g, '');
        for (let i = 0; i < this.loginCode.length; i++) {
          this.loginCode[i] = numericValue[i] || ''; 
        }
        
        // Auto-verify if we have a complete code
        setTimeout(() => {
          if (this.loginCode.every(code => code && code.length === 1)) {
            this.onVerifyCode();
          }
        }, 200);
      },

      handleKeydown(event, index) {
        if ((event.metaKey || event.ctrlKey) && event.key === 'v') {
          return; 
        }
        if (!/^[0-9]$/.test(event.key) && 
            !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          return;
        }

        if (event.key === 'Backspace') {
          if (!this.loginCode[index] && index > 0) {
            this.$nextTick(() => {
              const inputs = document.querySelectorAll('.otp-box input');
              if (inputs[index - 1]) {
                inputs[index - 1].focus();
              }
            });
          }
        }
      },
      closeModal() {
        if (this.loginStep == 2 || this.loginStep == 3) {
          this.loginStep = 1;
        } else {
          this.resetOpenThumbsUp();
          this.SET_OPEN_REFERRAL(false)
          this.setLoginDialog(false)
        }
      },
      focusNext(index) {
        if (index < 5) {
          const inputs = document.querySelectorAll('.otp-box input');
          if (inputs[index + 1]) {
            inputs[index + 1].focus();
          }
        }
        if (this.loginCode.join('').length === 6) {
          this.onVerifyCode();
        }
      },
      extractReferrer() {
        const urlParams = new URLSearchParams(window.location.search);
        this.referrer = urlParams.get('referrer') || '';
      },
      async onGuestAction() {
        if (this.loading)
          return

        this.loading = true

        try {
          const checkoutComplete = new Promise((resolve, reject) => {
            const successHandler = () => {
              resolve();
              cleanup();
            };
            
            const errorHandler = (error) => {
              reject(error);
              cleanup();
            };
            
            const cleanup = () => {
              this.$bus.$off('guestCheckoutSuccess', successHandler);
              this.$bus.$off('guestCheckoutError', errorHandler);
              
              clearTimeout(timeoutId);
            };
            
            const timeoutId = setTimeout(() => {
              reject(new Error('Checkout request timed out'));
              cleanup();
            }, 30000);
            
            this.$bus.$on('guestCheckoutSuccess', successHandler);
            this.$bus.$on('guestCheckoutError', errorHandler);
          });
          
          this.$bus.$emit('guestCheckoutRequested');
          
          await checkoutComplete;
          
          this.setLoginDialog(false);
        } catch(e) {
          console.log(''+e);
          this.$api.post('/order/error', {
            error: ''+e,
            statusCode: 505,
            storeId: this.getStore.storeId
          });
          
          this.showSnack({
            text: 'Failed to process order. Please try again.',
            color: 'error'
          });
        } finally {
          this.loading = false;
        }
      },

      onChangeGuestLogin(val) {
        this.setSelectedGuestLogin(!!val)
        this.loginStep = val ? 3 : 1
      },

      startCountdown() {
        this.interval = setInterval(() => {
          this.timeoutCounter++

          if (this.timeoutCounter >= 60) {
            this.stopCountdown()
            this.showResend = true
          }
        }, 1000)
      },
      stopCountdown() {
        clearInterval(this.interval)
        this.timeoutCounter = null
        this.showResend = false
      },

      evaluateError(error, errorObject) {
          if (errorObject) {
          this.showSnack({
            text: errorObject.msg,
            color: 'error'
          })
          }
         else if (error && error.request) {
          this.showSnack({
            text: 'Failed to read code, please try again',
            color: 'error'
          })
          this.loginStep = 1
          // this.mobileNumber = ''
        } else if (errorObject) {
          this.showSnack({
            text: errorObject,
            color: 'error'
          })
        } else {
          this.showSnack({
            text: error.msg,
            color: 'error'
          })
        }
        this.loginCode = ['', '', '', '', '', '']
      },

      onLogin() {
        if (!this.canLogin) return;
        this.$validator.validate().then(valid => {
          const phoneErrorItem = this.errors.items.find(error => error.field === 'phone_number')
          if (phoneErrorItem) {
            this.evaluateError(phoneErrorItem)
          }
          if (!this.errors.has('phone_number')) {
            this.isLoading = true

            this.loginRequest({ telephone: this.mobileNumber }).then((res) => {
              if (!this.hasConsentForGroup && this.consentChecked && this.storeGroupId) {
                try {
                  let consentedGroups = JSON.parse(localStorage.getItem('snappy_login_consent_groups') || '[]');
                  if (!consentedGroups.includes(this.storeGroupId)) {
                    consentedGroups.push(this.storeGroupId);
                    localStorage.setItem('snappy_login_consent_groups', JSON.stringify(consentedGroups));
                  }
                } catch (e) {}
              }
              this.loginStep = 2

              this.showResend = false
              this.timeoutCounter = 0
              this.startCountdown()
              setTimeout(() => {
                const inputs = document.querySelectorAll('.otp-box input');
                if (inputs && inputs.length > 0) {
                  inputs[0].focus();
                }
              }, 300);
            }).catch(error => {
              this.evaluateError(error, {
                field: 'phone_number',
                msg: findErrorMessage(error) || this.$vuetify.t('$vuetify.errors.errorLogin')
              })
            }).finally(() => {
              this.isLoading = false
            })
          }
        });
      },

      onVerifyCode() {
        if (this.isLoading || this.isLoggedIn)
          return

        const code = this.loginCode.join('');
        if (code.length !== 6) {
          this.showSnack({
            text: 'Please enter a 6 digit code',
            color: 'error'
          })
          return
        }
        this.isLoading = true
        this.extractReferrer()
        const loginObject = {
          telephone: this.mobileNumber,
          code,
          ...(this.referrer ? { referrer: this.referrer } : {})
        };

        this.login(loginObject).then(() => {
          this.setLoginDialog(false)
          if (this.getOpenReferral) {
            this.$root.$refs.referral.openDialog();
            this.SET_OPEN_REFERRAL(false)
          }
          this.$bus.$emit('loggedIn')
          this.fetchAccountDetails()
          this.setExistingOrder()
          this.fetchShoppingCart()
          this.stopCountdown()
          this.fetchThumbsUpHistory()
          this.$store.dispatch('groupOrder/recoverGroupOrder')
        }).catch(error => {
          this.evaluateError(error, {
            field: 'login_code',
            msg: this.$vuetify.t('$vuetify.errors.codeIncorrect')
          })
        }).finally(() => {
          this.isLoading = false
        })
      },

      ...mapActions([  'fetchThumbsUpHistory', 'showSnack', 'loginRequest', 'login', 'setExistingOrder', 'fetchAccountDetails', 'fetchShoppingCart']),
      ...mapMutations([ 'setLoginDialog', 'SET_CART_LOADING', 'setSelectedGuestLogin', 'SET_OPEN_REFERRAL' ])
    },

    watch: {
      canCheckoutAsGuest() {
        if (this.canCheckoutAsGuest) {
            // If guest becomes available again (back to dine in) and the user has selectedGuestLogin, return to that state
            if (this.isSelectedGuestLogin)
                this.loginStep = 3
        } else if (this.loginStep > 1) {
            // otherwise, if it becomes unavailable also show the login page
            this.loginStep = 1
        }
      },

      isInKioskMode() {
        // when using kiosk mode, auto assign guest, unless already set as guest
        if (this.isInKioskMode && this.step != 3)
          this.onChangeGuestLogin(true)
      },

      // Need to manually trigger an update when switching languages to update the fields name
      // Unfortunatly this doesn't seem to have a global affect so needs to
      // be included in all pages that use vee-validate
      '$vuetify.lang.current'() {
        this.$nextTick(() => {
          this.$validator.validateAll();
        })
      },

      // Watch for iOS autofill that might not trigger input events properly
      loginCode: {
        handler(newVal, oldVal) {
          // Check if the first field suddenly got a multi-digit value
          if (newVal[0] && newVal[0].length > 1 && (!oldVal[0] || oldVal[0].length <= 1)) {
            setTimeout(() => {
              this.distributeSixDigitCode(newVal[0]);
            }, 50);
          }
        },
        deep: true
      }
    },

    mounted() {
      this.$nextTick(() => {
        if (this.$refs.txtPhoneNumber)
          this.$refs.txtPhoneNumber.focus()

        const { phoneNumber } = this.$route.query

        if (phoneNumber)
          this.mobileNumber = phoneNumber

          // when using kiosk mode, auto assign guest, unless already set as guest
          if (this.isInKioskMode && this.step != 3)
            this.onChangeGuestLogin(true)
      })
    }
  }
</script>

<style scoped>
  .consent-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
  }

  .consent-checkbox {
    flex: 0 0 auto;
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
    min-width: auto !important;
    height: auto !important;
  }

  .consent-checkbox >>> .v-input--selection-controls__input {
    margin: 0 !important;
    width: 18px !important;
    height: 18px !important;
  }

  .consent-checkbox >>> .v-input--selection-controls__ripple {
    display: none !important;
  }

  .consent-checkbox >>> .v-icon {
    font-size: 18px !important;
    width: 18px !important;
    height: 18px !important;
  }

  .consent-text {
    font-size: 14px;
    line-height: 1.4;
    flex: 1;
  }
  .v-stepper {
    margin: 0 auto !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
  .v-stepper__content {
    padding: 0 16px !important;
    box-sizing: border-box !important;
  }
  .layout-verify {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    flex-wrap: nowrap; 
    gap: 4px; 
  }

  .disclaimer {
    font-size: 12px;
    color: grey;
    text-align: left;
    margin: 10px 0;
    padding-top: 10px;
  }

  .disclaimer >>> a {
    color: inherit;
    text-decoration: underline;
  }

  .disclaimer >>> a:hover {
    opacity: 0.8;
  }
  .guest-actions-container {
    padding: 20px 0;
    padding-top: 0px;
    gap: 16px;
    width: 100%;
    display: flex;
    justify-content: center !important;
  }

  .guest-action-btn {
    height: 50px !important;
    font-size: 14px;
    background-color: var(--v-primary-base) !important;
    color: white !important;
    font-weight: bold;
    width: 100%;
    border-radius: 25px !important;
    margin: 0 !important;
  }
  .login-text {
    font-weight: 800;
    font-size: 13px;
    margin-bottom: 10px;
  }
  .v-stepper, .v-stepper__header {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .v-stepper__wrapper button{
    text-align: center;
  }

  .v-stepper__header {
    height: 30px !important;
    position: relative !important;
    margin-bottom: 10px !important;
  }
  .v-stepper__step {
    padding: 10px 24px 15px !important;
  }

  .curNumber {
      font-size: 12px;
  }

  .xs5 .v-btn, .xs12 .v-btn, .xs .v-btn {
    width: 100%;
    margin: 6px 0px;
  }

  .disclaimer {
    font-size: 12px;
    color: grey;
    text-align: left;
    padding-bottom: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .captcha {
    font-size: 12px;
    color: grey;
    text-align: left;
  }
  .done-button {
    font-size: 14px;
    background-color: var(--v-primary-base)!important;
    color: white !important;
    font-weight: bold;
    width: 100%;
    margin-top: 1rem;
    border-radius: 25px;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .options-button {
    height: 50px;
    font-size: 14px;
    background-color: var(--v-primary-base)!important;
    color: white !important;
    font-weight: bold;
    width: 48.5%;
    margin-top: 1rem;
    border-radius: 25px;
  }
      
  .otp-box {
    height: 48px !important;
    width: calc((100% - 25px) / 6) !important; 
    max-width: 51px !important;
    margin: 0 !important;
    min-width: 30px !important;
    flex: 1 1 0 !important; 
  }

  .otp-box /deep/ .v-input__control,
  .otp-box /deep/ .v-input__slot {
    height: 48px !important;
    width: 100% !important;
    background-color: #F5F5F5 !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }

  .otp-box /deep/ input {
    text-align: center !important;
    font-size: 18px !important; /* Slightly smaller font */
    font-weight: bold !important;
    background-color: #F5F5F5 !important;
    padding: 0 !important;
  }

  .otp-box /deep/ input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  .otp-box /deep/ input[type="number"]::-webkit-inner-spin-button,
  .otp-box /deep/ input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .phone-input {
    max-width: 100% !important;
    margin-top: 15px !important;
  }

  .phone-input /deep/ .v-input__control {
    height: 48px !important;
    background-color: #F5F5F5 !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }

  .phone-input /deep/ .v-input__slot {
    height: 48px !important;
    background-color: #F5F5F5 !important;
    box-shadow: none !important;
    border-radius: 8px !important;
  }

  .phone-input /deep/ input {
    font-size: 20px !important;
    font-weight: bold !important;
    background-color: #F5F5F5 !important;
  }
  
  .phone-input /deep/ input[type="number"]::-webkit-inner-spin-button,
  .phone-input /deep/ input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .phone-input /deep/ input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  .v-layout.row.wrap.justify-center {
    margin: 0 auto !important;
    padding: 0 !important;
    width: 100% !important;
  }
  
  .v-card__actions {
    justify-content: center;
    padding: 0 16px;
  }

  .title-text {
    font-size: 1.45em !important;
    margin: 0;
    font-weight: 900;
    width: 100%;
    text-align: center;
  }
  
  .close-btn {
    position: absolute !important;
    right: 8px !important;
    top: 8px !important;
    margin: 0 !important;
    z-index: 10 !important;
  }

  .header-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    min-height: 64px;
    width: 100%;
    margin-top: 16px;
  }

  .header-title {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    box-shadow: none !important;
    margin: 0 !important;
    z-index: 1;
  }

  /* @media (max-width: 600px) {
    .v-dialog {
      position: relative !important;
      margin-top: 20px !important;
      margin-bottom: 20px !important;
      max-height: calc(100vh - 40px) !important;
      overflow-y: auto !important;
    }
    .phone-input, .otp-box {
      z-index: 1;
      position: relative;
    }
    .v-stepper {
      scroll-behavior: smooth;
    }
  } */
  @media (max-width: 920px) {
  .layout-verify {
    margin-bottom: 15px !important;
    gap: 2px; 
  }
  
  .otp-box {
    height: 40px !important;
    min-width: 28px !important;
  }

  .otp-box /deep/ .v-input__control,
  .otp-box /deep/ .v-input__slot {
    height: 40px !important;
  }

  .otp-box /deep/ input {
    font-size: 16px !important;
  }
}
@media (max-width: 340px) {
  .otp-box {
    height: 36px !important;
    min-width: 24px !important;
  }
  
  .otp-box /deep/ .v-input__control,
  .otp-box /deep/ .v-input__slot {
    height: 36px !important;
  }
  
  .otp-box /deep/ input {
    font-size: 14px !important;
  }
}
</style>
<style>
  #Login .v-stepper__step__step {
    margin-right: 8px;
  }
  #Login .v-stepper__label {
      display: block !important;
  }
</style>
